/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from "react";
import {Redirect, Switch, Route} from "react-router-dom";
import {shallowEqual, useSelector} from "react-redux";
import {Layout} from "../_metronic/layout";
import BasePage from "./BasePage";
import {Logout} from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";

export function Routes() {

    const {isAuthenticated} = useSelector(
        ({auth}) => ({
            isAuthenticated: auth.user != null,
        }),
        shallowEqual
    );

    return (
        <Switch>
            {!isAuthenticated ? (
                /*Render auth page when user at `/auth` and not authorized.*/
                <Route path="/auth">
                    {/*    <Route path="/auth/atlas-grant" exact>*/}
                    {/*        <AtlasGrantTokenPage/>*/}
                    {/*    </Route>*/}
                    {/*<AuthPage />*/}
                </Route>
            ) : (
                /*Otherwise redirect to root page (`/`)*/
                <Redirect from="/auth" to="/"/>
            )}

            <Route path="/error" component={ErrorsPage}/>
            <Route path="/logout" component={Logout}/>

            {!isAuthenticated ? (
                /*Redirect to `/auth` when user is not authorized*/
                // <Redirect to="/auth/login" />
                <Redirect to="/error"/>
            ) : (
                <Layout>
                    <BasePage/>
                </Layout>
            )}
        </Switch>
    );
}
